import { Injectable } from '@angular/core';
import { of } from 'rxjs/observable/of';
import { catchError, finalize, map } from 'rxjs/operators';
import { AuthApiService } from '../core/services/api/auth-api.service';
import { UserNotificationApiService } from '../core/services/api/user-notification-api.service';
import { PendingService } from '../core/services/base/pending.service';

@Injectable()
export class AuthService {
  constructor(
    private authApiService: AuthApiService,
    private pendingService: PendingService,
    private userNotificationApiService: UserNotificationApiService
  ) { }

  login(email: string, password: string) {
    return this.authApiService.login(email, password).toPromise();
  }

  recoverPassword(email: string) {
    return this.authApiService.recoverPassword(email).toPromise();
  }

  resetPassword(hash: string, password: string, passwordRepeat: string) {
    return this.authApiService.resetPassword(hash, password, passwordRepeat).toPromise();
  }

  resolveResetPassword(hash: string) {
    this.pendingService.addBlockingPending();
    return this.authApiService.checkPasswordRecoveringHash(hash)
      .pipe(
        map(() => true),
        catchError(() => of(false)),
        finalize(() => this.pendingService.removeBlockingPending())
      );
  }

  getUserNotificationIsNotReadCounter() {
    return this.userNotificationApiService.getUserNotificationIsNotReadCounter().toPromise();
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/auth/auth.service.ts